import { FirebaseOptions, getApp, initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB0Bc8e5OjlB-SgOW7Mzjd4zwGG53bxa9k",
  authDomain: "editortimelapse.firebaseapp.com",
  projectId: "editortimelapse",
  storageBucket: "editortimelapse.appspot.com",
  messagingSenderId: "229136169101",
  appId: "1:229136169101:web:5e1a418172482b371c0ac4",
  measurementId: "G-EMMDESLZPC"
};

function createFirebaseApp(config: FirebaseOptions) {
  try {
    return getApp();
  } catch {
    return initializeApp(config);
  }
}

const app = createFirebaseApp(firebaseConfig);

// export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const database = getDatabase(app);

export default app;